import { Component, OnInit, Directive, ElementRef, Input, HostListener } from '@angular/core';

@Component({
   selector: 'app-tooltip',
   template: ``,
   styleUrls: ['./tooltip.component.sass']
})
export class TooltipComponent implements OnInit {
   // @Input()

   constructor() { }

   ngOnInit() {
   }

}

@Directive({
   selector: '[tooltip]'
})
export class TooltipDirective {
   @HostListener('mouseover', ['$event']) onOver(e: MouseEvent) {
      // console.log(`Over`, e);
   }

   @HostListener('mouseout', ['$event']) onOut(e: MouseEvent) {
      // console.log(`Out`, e);
   }

   private hostDom: HTMLElement;

   constructor(
      hostDomRef: ElementRef,
   ) {
      this.hostDom = hostDomRef.nativeElement;
   }
}

